<template>
  <header>
    <!-- <router-link to="/">
      <img class="geometric-logo" src="../assets/Logo/geometric.svg" />
    </router-link> -->
    <div>
      <img class="geometric-logo" src="../assets/Logo/geometric.svg" />
    </div>
    <div class="nav-right">
      <nav class="nav-bar">
        <ul>
          <li>
            <a
              class="header-item"
              :href="`https://geometric.anagraph.io/${$i18n.locale}`">
                {{ messages.about }}
            </a>
          </li>
          <li>
            <a class="header-item"
            :href="messages.contactSupport">
              Support
            </a>
          </li>
          <li>
            <locale-changer
              class="header-item"
            />
          </li>
        </ul>
      </nav>
      <user-auth  v-if="shopifyStore">{{ shopifyStore }}</user-auth>
      <user-auth  v-else/>
    </div>
  </header>
</template>
<script>
import { mapState } from 'vuex'
import LocaleChanger from './PageHeader/LocaleChanger.vue'
import UserAuth from './auth/UserAuth.vue'

export default {
  components: {
    LocaleChanger,
    UserAuth
  },
  computed: {
    messages () {
      return this.$t('message.pageHeader')
    },
    ...mapState('auth', [
      'profile'
    ]),
    shopifyStore () {
      if (Object.keys(this.profile).length !== 0) {
        return this.profile.uid.match('shopify') ? this.profile.uid : this.profile.isAnonymous ? process.env.VUE_APP_SHOPIFY_STORE : null
      } else return null
    }
  }
}
</script>

<style  lang="scss">
header {
  padding: 0 20px;
  height: 72px;
  background-color: #20212C;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    text-decoration: none;
  }
  .geometric-logo {
    height: 28px;
  }
  .header-item {
    font-size: 13px;
    font-family: 'geomanist-medium';
    font-weight: 400;
    letter-spacing: 0.2px;
    color: #ffffff;
    padding: 0 12px;
  }
  .nav-right {
    display: flex;
    align-items: center;
    ul {
      list-style: none;
      display: flex;
    }
  }
}
</style>
